import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BackNavigationDirective } from './back-navigation.directive';

/**
 * Module that provides navigation utilities for Angular applications.
 *
 * Features:
 * - BackNavigationDirective: Smart back navigation with fallback support
 *
 * Usage:
 * Import this module in any feature module that needs navigation utilities.
 *
 * Directive usage:
 * ```html
 * <button appNavigationBack [fallbackRoute]="'../../dashboard'">
 *   <i class="fas fa-arrow-left"></i> Back
 * </button>
 * ```
 *
 * The directive will:
 * 1. Navigate back in browser history if there's a previous page within the same site
 * 2. Navigate to the fallbackRoute if no in-site history exists (e.g., direct URL access)
 */
@NgModule({
  declarations: [BackNavigationDirective],
  imports: [CommonModule],
  exports: [BackNavigationDirective],
})
export class NavigationModule {}
